import React, { Component } from "react";

class ActivityMenu extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			activityArray: []
		}
	}
 
	componentDidMount(){
		if ( localStorage.getItem('userData') )   
			{
				var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
				
				if ( sessionData.scriptDetail && sessionData.scriptDetail.length > 0 ) 
					{ 
						if ( window.location.href.indexOf('guest') > -1 && !sessionData.ondemandId )
							{
								for ( let i = 0; i < sessionData.scriptDetail.length; i++ )
									{
										if ( sessionData.scriptDetail[i]['attribute'][0]['attrValue'] == 'Pause' || sessionData.scriptDetail[i]['attribute'][0]['attrValue'] == 'Pause Virtual' )
											{
												sessionData.scriptDetail.splice(i, 1);
												i--;
											}
									}
							}
							
						this.setState({activityArray: sessionData.scriptDetail});
					}
			}
	}
	
	
	render() {
		return (
			<div className="right_menu_streaming">
				<div className="right_menu_title">Activities
					<div className="right_close" onClick={() => this.props.updateStateFromChild({rightMenuOpen: false, activityListOpen: false})}></div>
				</div>
				<div className="activity_container_menu">
					{ this.state.activityArray.map((item, i) =>
						<div className="one_activity_menu" id={'workout'+item.id} key={i}>
							{ item.attribute[12] && item.attribute[12].attrValue && item.attribute[12].attrValue !== '' ? 
								<div className="workout_name">{item.attribute[12].attrValue}</div>
								:
								<div className="workout_name">{item.name}</div>
							}
							<div className="success_work"></div>
							{ item.attribute[4].attrValue && item.attribute[4].attrValue !== '' && 
								<div className="play_activity" onClick={() => this.props.playActivityVideo(item.attribute[4].attrValue)}></div>
							}
							<div className="workout_duration">{item.attribute[2].attrValue} <span>{item.attribute[1].attrValue === 'Time' ? 'seconds' : 'Repetitions'}</span></div>
						</div>
					)} 
				</div>
			</div>		
	)}
}
export default ActivityMenu;
